import React, { Component } from 'react';
import { Loading } from "common-import/custom";
import { VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import { isEqual, isEmpty } from "lodash";
import v from "voca";
import { Request } from "../../utils";

const Text = [
  "name",
  "firstName",
  "lastName",
  "email",
  "position",
  "phone",
  "mobile",
];

const Number = [];

const Select = [
  "gender",
];

const propertyContact = [...Text, ...Select];
const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

@inject("contactStore", "userStore") @observer
export default class ContactDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isSaving: false,
      current: {},
      backup: {},
      avatar: {
        file: null,
        url: '',
      },
    };
  };

  async componentDidMount() {
    const { userStore, contactStore, match } = this.props;
    await userStore.onReady();
    const res = await contactStore.detail({ id: match.params.id });
    this.setState({ isLoading: false });
    if (!!res.error) return window.toast.error(JSON.stringify(res.error));
    this.setState({ current: res.data, backup: res.data }, () => {
      console.log(this.state.current);
      this.forceUpdate();
    });
  };

  renderFormEdit = () => {
    const genderOptions = [
      { value: '', label: '' },
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' },
    ];

    const renderOptions = (prop) => {
      return genderOptions.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    return (<form className="block-content">
      <h4 className="block-content__title">
        <i className="fa fa-pencil" aria-hidden="true"> </i>
        Edit Contact information
      </h4>
      <div className="row">
        {
          propertyContact.map((property, index) => {
            let element;
            console.log(property, this.state.current[property]);
            if (Number.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="number"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  value={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>
            } else if (Select.includes(property)) {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <select
                  id={"nf-" + property}
                  name={"nf-" + property}
                  className="form-control"
                  value={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                  placeholder={v.capitalize(property)}
                >
                  {renderOptions(property)}
                </select>
              </div>
            } else {
              element = <div className="position-relative form-group">
                <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                <input
                  type="text"
                  className="form-control"
                  id={"nf-" + property}
                  name={"nf-" + property}
                  value={this.state.current[property] || ''}
                  onChange={e => this.setState({
                    current: { ...this.state.current, [property]: e.target.value }
                  })}
                />
              </div>;
            }

            return (
              <div className="col-md-6" key={"property" + index}>
                {element}
              </div>
            );
          })
        }
      </div>
    </form>)
  };

  changeAvatar = (e) => {
    !!e && e.preventDefault();
    const { current } = this.state;
    this.setState({
      avatar: {
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0])
      },
      current: { ...current, avatar: URL.createObjectURL(e.target.files[0]) }
    })
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeString: ["id", "name", "firstName", "lastName", "email", "phone", "mobile", "avatar", "gender", "position"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  saveChanges = async () => {
    const { contactStore } = this.props;
    const { current, avatar } = this.state;

    this.setState({ isSaving: true });

    if (avatar.file !== null) {
      const avatarURL = await Request.upload(avatar.file);
      this.setState({ current: { ...current, avatar: avatarURL } })
    }

    const payload = this.formatPayload(this.state.current);
    const res = await contactStore.update(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }
    window.history.back();
    return window.toast.info('Updated successfully.');
  };

  // cancelEdit = () => {
  //   if (!window.confirm("Are you sure want to cancel the changes?")) return null;
  //   this.setState({ current: this.state.backup });
  // };

  deleteContact = async () => {
    if (!window.confirm("Are you sure want to DELETE contact?")) return null;
    const { contactStore } = this.props;
    const res = await contactStore.delete({ id: this.state.current.id });
    if (!!res.error) {
      return window.toast.error(JSON.stringify(res.error));
    }
    window.toast.info('Deleted');
    window.history.back();
  }

  render() {
    const { isLoading, isSaving, current } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    console.log('avatar', current.avatar);
    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            <strong>{current.name}</strong>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                {this.renderFormEdit()}
              </div>
              <div className="col-md-6">
                <div className="user-profile__image bg-image"
                  style={{ backgroundImage: `url('${VarHelper.img(current.avatar) || defaultImage}')` }}>
                  <input onChange={this.changeAvatar} style={{ display: 'none' }} type="file" id="tu-edit-avatar" name="avatar" />
                </div>
                <div style={{ justifyContent: 'center', display: 'flex', alignItems: 'center', marginTop: 20 }}>
                  <label htmlFor="tu-edit-avatar" style={{ display: 'inline-block' }} className="btn btn-danger icon-edit">
                    <i className="fa fa-pencil" aria-hidden="true"> </i> Edit
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-default" onClick={e => window.location.history.goBack()}>
              <i className="fa fa-arrow-left"> </i> back
            </button>
            <button disabled={isSaving} className="btn btn-sm btn-primary" onClick={e => this.saveChanges(e)}>
              <i className="fa fa-dot-circle-o"> </i> {isSaving ? 'Saving...' : 'Save'}
            </button>
            <button className="btn btn-sm btn-danger" onClick={e => this.deleteContact(e)}>
              <i className="fa fa-ban"> </i> Delete
            </button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Contacts/Detail.js